import { FC } from 'react';
import { Button } from '@cfa/react-core';
import { themeSizes } from '../../../styles/globalStyleVars';

interface Props {
  onClick?: () => void;
}

export const AffectsMeButton: FC<Props> = ({ onClick }) => (
  <Button
    data-testid={'affects-me-button'}
    variant='outlined'
    size='sm'
    style={{
      padding: `1px ${themeSizes.md}`,
      backgroundColor: 'white',
      maxWidth: 'fit-content',
    }}
    onPress={onClick}
  >
    This affects my restaurant
  </Button>
);
